define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/ClientUtil',
	'service/QRCodeService',
	'view/UIView',
	'canvas/CameraCanvas',
	'amdi18n-loader?!view/nls/ScanQRCodeView_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	ClientUtil,
	QRCodeService,
	UIView,
	CameraCanvas,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * ScanQRCodeView class
	 */
	function ScanQRCodeView(scanCallback) {
		var _self = this,
			_scanCallback = scanCallback,
			_cameraCanvas = new CameraCanvas(),
			_qrCodeService = new QRCodeService(),
			_defaultConstraints = {
					video: {
//						optional: [
							 width: 800 ,
							 height:600,
							//{ frameRate: 60 },
							 facingMode : "environment" 
//						]
					}, audio: false },
			_scanInterval = 66, // in ms
			_stream = null,
			_videoEnabled = false,
			_enabled = true,
			_view;

		_view = (function () {
			var $view = jQuery("<div id='skIdS_scan-qrcode-container'>" +
									"<div id='skIdS_scan-qrcode-mode-container' class='btn-group' role='group'>" +
										"<button id='skIdS_scan-qrcode-video-mode' type='button' class='btn btn-default'>" + Strings.video + "</button>" +
										"<button id='skIdS_scan-qrcode-photo-mode'  type='button' class='btn btn-default'>" + Strings.photo + "</button>" +
									"</div>" +
									"<div id='skIdS_scan-qrcode-video-container'>" +
										"<select id='skIdS_scan-qrcode-video-source' class='form-control'></select>" +
										"<video id='skIdS_scan-qrcode-video' autoplay></video>" +
									"</div>" +
									"<div id='skIdS_scan-qrcode-photo-container'>" +
										"<div id='skIdS_scan-qrcode-photo-button'>" +
											"<input id='skIdS_scan-qrcode-photo' name='qr_code' type='file' accept='image/*; capture=camera' />" +
										"</div>" +
										"<div id='skIdS_scan-qrcode-photo-info' class='alert alert-info'></div>" +
									"</div>" +
								"</div>");

			$view.find('#skIdS_scan-qrcode-photo-button').prepend(jQuery(_cameraCanvas.get()).attr('id', 'skIdS_scan-qrcode-photo-image'));

			$view.find('#skIdS_scan-qrcode-mode-container > button').on('click', function () {
				if (this === $view.find('#skIdS_scan-qrcode-video-mode')[0]) {
					changeMode('video');
				} else {
					changeMode('photo');
				}
			});

			$view.find('#skIdS_scan-qrcode-video-source')
					.hide()
					.on('change', function () {
						var constraints = Util.copy(_defaultConstraints);

						constraints.video.deviceId = jQuery(this).val();
						console.log(constraints);

						if (_stream !== null) {
							var track = _stream.getTracks()[0];
							track.stop();
						}

						createStream(constraints);
					});

			$view.find('#skIdS_scan-qrcode-photo').on('change', function() {
				if (this.files && this.files[0]) {
					_self.showLoadingIndicator();

					decodeImage(this.files[0]);
				}
			});

			return $view;
		})();

		UIView.call(this);


		// private methods

		function currentMode() {
			if (_view.find('#skIdS_scan-qrcode-video-mode').hasClass('active')) {
				return 'video';
			}

			return 'photo';
		}

		function changeMode(mode, force) {
			if (currentMode() === mode && !force) {
				return;
			}

			switch (mode) {
			case 'video':
				_qrCodeService.cancelDecode();

				startVideo();

				_view.find('#skIdS_scan-qrcode-video-container').show();
				_view.find('#skIdS_scan-qrcode-photo-container').hide();

				_view.find('#skIdS_scan-qrcode-video-mode').addClass('active');
				_view.find('#skIdS_scan-qrcode-photo-mode').removeClass('active');
				break;
			case 'photo':
				stopVideo();

				_qrCodeService.cancelDecode();

				//_view.find('#skIdS_scan-qrcode-photo-container').show();
				_view.find('#skIdS_scan-qrcode-photo-container').css('display', '');

				_view.find('#skIdS_scan-qrcode-video-container').hide();

				_view.find('#skIdS_scan-qrcode-photo-mode').addClass('active');
				_view.find('#skIdS_scan-qrcode-video-mode').removeClass('active');

				_view.find('#skIdS_scan-qrcode-photo-info').hide();
				break;
			}

			UiUtil.scrollTo(_view.get());
		}

		function startVideo() {
			var $select = _view.find('#skIdS_scan-qrcode-video-source');

			_videoEnabled = true;

			if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
				$select.empty()
						.show();

				navigator.mediaDevices.enumerateDevices().then(function(sourceInfos) {
					var videoStreams = new Array(),
						sourceInfo,
						$option,
						constraints = Util.copy(_defaultConstraints),
						activated = false,
						i;

					for (i = 0; i < sourceInfos.length; i++) {
						sourceInfo = sourceInfos[i];

						if (sourceInfo.kind === 'videoinput') {
							$option = jQuery('<option value="' + sourceInfo.deviceId + '">' +
												(sourceInfo.label || (Strings.camera + ' ' + i)) +
											'</option>');

							if (sourceInfo.facing === 'environment') {
								activated = true;

								constraints.video.deviceId = sourceInfo.deviceId ;

								createStream(constraints);

								$option.prop('selected', true);
							}

							videoStreams.push(sourceInfo.deviceId);

							$select.append($option);
						}
					}

					if (!activated && videoStreams.length > 0) {
						constraints.video.deviceId = videoStreams[0] ;

						createStream(constraints);
					}
				});
			} else {
				createStream(_defaultConstraints);

				$select.hide();
			}
		}

		function createStream(constraints) {
			if (navigator.mediaDevices.getUserMedia) {
				navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
					initStream(null, stream);
				}).catch(error);
			} else if (navigator.mediaDevices.webkitGetUserMedia) {
				navigator.mediaDevices.webkitGetUserMedia(constraints, function (stream) {
					initStream('webkit', stream);
				}, error);
			} else if (navigator.mediaDevices.mozGetUserMedia) {
				navigator.mediaDevices.mozGetUserMedia(constraints, function (stream) {
					initStream('moz', stream);
				}, error);
			}
		}

		function error() {
			changeMode('photo');
		}

		function initStream(impl, stream) {
			var video = _view.find('#skIdS_scan-qrcode-video')[0];

			switch (impl) {
			case 'webkit':
				video.src = window.URL.createObjectURL(stream);
				break;
			case 'moz':
				video.mozSrcObject = stream;
				video.play();
				break;
			default:
				video.srcObject = stream;
				break;
			}

			_stream = stream;

			decodeVideo();
		}

		function stopVideo() {
			_videoEnabled = false;

			if (_stream !== null) {
				try {
					var track = _stream.getTracks()[0];
						track.stop()
				} catch (e) {
					// implement error handling
				}

				_stream = null;
			}
		}

		function decodeVideo() {
			var video = _view.find('#skIdS_scan-qrcode-video')[0];

			if (_videoEnabled) {
				if (video.videoWidth && video.videoHeight) {
					_qrCodeService.decode(video, decodeComplete);
				}

				window.setTimeout(decodeVideo, _scanInterval);
			}
		}

		function decodeImage(image) {
			var fileReader = new FileReader();

			fileReader.onload = function (event) {
				var image = new Image();

				image.onload = function () {
					_qrCodeService.decode(image, decodeComplete);
				};

				image.onerror = function () {
					decodeComplete(null);
				};

				image.src = event.target.result;
			};

			fileReader.onerror = function () {
				decodeComplete(null);
			};

			fileReader.readAsDataURL(image);
		}

		function decodeComplete(decodedData) {
			if (_enabled && decodedData !== null) {
				Util.callCallbacks(_scanCallback, decodedData);
			} else if (decodedData === null && currentMode() === 'photo') {
				_view.find('#skIdS_scan-qrcode-photo-info')
						.empty()
						.append(Strings.decode_failed);

				if (!_view.find('#skIdS_scan-qrcode-photo-info').is(':visible')) {
					_view.find('#skIdS_scan-qrcode-photo-info').show();
				}

				UiUtil.scrollTo(_view.find('#skIdS_scan-qrcode-photo-info'));
			}

			_self.hideLoadingIndicator();
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function () {
			_enabled = true;

			if (ClientUtil.supportsUserMedia()) {
				changeMode('video', true);
			} else {
				_view.find('#skIdS_scan-qrcode-mode-container').hide();

				changeMode('photo', true);
			}
		};

		this.enableScan = function () {
			_enabled = true;
		};

		this.disableScan = function () {
			_enabled = false;

			stopVideo();
		};
	}

	ScanQRCodeView.prototype = Object.create(UIView.prototype);

	return ScanQRCodeView;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ScanQRCodeView.js
// module id = 349
// module chunks = 1